import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, DestroyRef, inject, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { FieldType } from '@ngx-formly/core';
import { TimeLineDisplayOptions } from '../components/timeline-item/timeline-item.component';
import { TimelineComponent } from '../components/timeline/timeline.component';

@Component({
    selector: 'app-formly-timeline-widget',
    templateUrl: './formly-timeline-widget.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: {
        class: 'flex h-full min-h-0 w-full flex-col',
    },
    imports: [
        CommonModule,
        TimelineComponent
    ]
})
export class FormlyTimelineWidgetComponent extends FieldType implements OnInit {
  private readonly destroyRef = inject(DestroyRef);

  readyToLoadAcivityStream = false;

  actorId: string;
  targetId: string;
  objectId: string;

  displayOptions: TimeLineDisplayOptions;

  constructor(
    // private cdRef: ChangeDetectorRef,
  ) {
    super();
  }

  ngOnInit(): void {
    this.formControl?.valueChanges
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(x => {
        this.buildFilter();
      });

    if (this.props?.attributes?.actorFilter || this.props?.attributes?.targetFilter)
      this.buildFilter();
  }

  buildFilter(): void {

    this.displayOptions = {
      hideCategory: this.props?.attributes?.hideCategory == 1
    }

    if (!this.model) {
      console.log("No model - Fomrly Timeline Widget");
      return;
    }

    if (this.props?.attributes?.actorFilter)
      this.actorId = this.model[this.key as string];

    if (this.props?.attributes?.targetFilter)
      this.targetId = this.model[this.key as string];

    if (this.props?.attributes?.objectFilter)
      this.objectId = this.model[this.key as string];

    this.readyToLoadAcivityStream = true;

    // this.cdRef.detectChanges();
    this.options.detectChanges(this.field);
  }
}
